import {
  GraphAxiesEnum,
  GraphNameEnum,
  TableNameEnum,
} from '@/pages/dashboard-search/types/enums';
import type { activeTabConfigMemo } from '.';
import type {
  IChartLabels,
  ILineConfigItem,
  IScatterConfigItem,
  ITableData,
  ITreeMapConfigItem,
} from '../../../types';
import { ChartsTypeEnum } from '../../../types';

export default (
  activeTabConfig: ReturnType<typeof activeTabConfigMemo>,
  type: ChartsTypeEnum,
  labels: IChartLabels | null,
  nameMainValue: string
): ITableData => {
  const getTableHeaders = () => {
    switch (type) {
      case ChartsTypeEnum.scatter: {
        if (nameMainValue === GraphNameEnum.soi)
          return [
            TableNameEnum.brand,
            TableNameEnum.averageProducts,
            TableNameEnum.soi,
            TableNameEnum.averagePositon,
          ];
        else
          return [
            TableNameEnum.brand,
            TableNameEnum.averagePositions,
            TableNameEnum.sos,
            TableNameEnum.averagePositon,
          ];
      }
      case ChartsTypeEnum.line: {
        return [TableNameEnum.brand, GraphAxiesEnum.date, nameMainValue];
      }
      case ChartsTypeEnum.barStack: {
        return [TableNameEnum.brand, GraphAxiesEnum.date, nameMainValue + ' %'];
      }
      case ChartsTypeEnum.treeMap:
        return [TableNameEnum.brand, nameMainValue];
      default: {
        return [];
      }
    }
  };

  const getTableData = () => {
    // if (!labels) return [];
    switch (type) {
      case ChartsTypeEnum.line: {
        return [...(activeTabConfig as ILineConfigItem[])]
          .reverse()
          .map(({ brand, date, yValue }) => [brand, date, yValue]);
      }
      case ChartsTypeEnum.treeMap: {
        return (activeTabConfig as ITreeMapConfigItem[]).map(
          ({ name, sizeValue }) => [name, sizeValue]
        );
      }
      case ChartsTypeEnum.scatter: {
        if (!labels) return [];
        return (activeTabConfig as IScatterConfigItem[]).map(
          ({ name, value, originalSymbolSize }) => [
            name,
            originalSymbolSize,
            value[0],
            value[1],
          ]
        );
      }
      case ChartsTypeEnum.barStack: {
        return [...(activeTabConfig as ILineConfigItem[])]
          .reverse()
          .map(({ brand, date, yValue }) => [brand, date, yValue]);
      }

      default: {
        return [];
      }
    }
  };

  const tableHeaders = getTableHeaders();
  const tableData = getTableData();

  return {
    tableHeaders,
    tableData,
  };
};
